import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  TableRow,
  TableCell,
  Collapse,
  Box,
  Typography,
  IconButton,
} from "@material-ui/core";
import plusIcon from "./../../assets/svg/icon-plus.svg";
import minusIcon from "./../../assets/svg/icon-minus.svg";

const getSelectedVersion = (version) => {
  console.log(version);
};

const CollapseRow = ({ name, num, selectedVersion, onOpen }) => {
  const [open, setOpen] = React.useState(false);
  const [versions, setVersions] = React.useState([]);
  const location = useLocation();

  const onclick = () => {
    onOpen && onOpen(setVersions);
    setOpen(!open);
  };
  return (
    <>
      <TableRow onClick={onclick}>
        <TableCell component="th" scope="row">
          {name}
        </TableCell>
        <TableCell align="right">{num}</TableCell>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <img className="graph" src={minusIcon} alt="Close" />
            ) : (
              <img className="graph" src={plusIcon} alt="Open" />
            )}
          </IconButton>
        </TableCell>
      </TableRow>
      {open ? (
        <TableRow>
          <TableCell colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1} className="box">
                {versions.map((value) => (
                  <Link
                    key={value.Code}
                    to={{
                      pathname:
                        location.pathname + "/" + name + "/" + value.Code,
                      data: value,
                    }}
                    onClick={getSelectedVersion.bind(this, selectedVersion)}
                  >
                    <Typography
                      key={value.Code}
                      variant="h6"
                      className="box-version"
                      gutterBottom
                      component="div"
                    >
                      {"V" + value.Code}
                    </Typography>
                  </Link>
                ))}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};

export default CollapseRow;
